<template>
  <div class="custom-Add">
    <el-form ref="form" :model="form" label-width="110px">
      <el-form-item label="名称：" prop="madeName">
        <el-input v-model="form.madeName"></el-input>
      </el-form-item>
      <el-form-item label="详细内容：" prop="madeContent">
        <editor
          :editContent="form.madeContent"
          @getValue="getEditorContent"
        />
      </el-form-item>
      <el-form-item class="submit">
        <el-button type="primary" :loading="loading" @click="onSubmit">保存</el-button>
        <el-button  @click="$router.push({ name:'CustomList'})">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { addPersonalMade } from '@/api/goods';
import Editor from '@/components/Editor';

export default {
  data() {
    return {
      loading: false,
      form: {
        madeName: '',
        madeContent: '',
      },
    };
  },
  components: {
    Editor,
  },
  methods: {
    addPersonalMade() {
      this.loading = true;
      addPersonalMade(this.form).then((res) => {
        if (res.success) {
          this.loading = false;
          this.$router.push({ name: 'CustomList' });
          this.$message.success('添加成功');
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onSubmit() {
      if (!this.form.madeName) {
        this.$message.warning('请输入商品名称');
      } else if (!this.form.madeContent) {
        this.$message.warning('请输入详细内容');
      } else {
        this.addPersonalMade();
      }
    },
    getEditorContent(value) {
      this.form.madeContent = value;
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/css/mixins'
.custom-Add
  padding-top 100px
  .el-form
    width 910px
    margin 0 auto
    .uploadImg
      flex-row()
      >>>.el-form-item__content
        margin-left 0!important
    .submit
      margin-top 100px
      text-align center
</style>
